import React from 'react'
import { ReceivingVariantSummary } from '../fixtures'
import { AsnSummaryDetails, CompactDetails, FieldHint, VariantProductName } from '../styles'
import { QuantityProgress } from './QuantityProgress'

export const VariantSummary = ({
  variant,
  lineAddedToAsn,
  additional = 0,
}: {
  variant: ReceivingVariantSummary
  lineAddedToAsn: boolean
  additional?: number
}) => (
  <>
    <VariantProductName>{variant.name}</VariantProductName>
    {lineAddedToAsn ? <FieldHint>Added during receiving</FieldHint> : null}
    <QuantityProgress
      planned={variant.expectedUnits + additional}
      received={variant.receivedUnits}
      expected={variant.expectedUnits}
      additional={additional}
    />
    {variant.description || variant.barcode ? (
      <CompactDetails>
        <summary>Product details</summary>
        <AsnSummaryDetails>
          {variant.description ? (
            <>
              <dt>Description</dt>
              <dd>{variant.description}</dd>
            </>
          ) : null}
          {variant.barcode ? (
            <>
              <dt>Barcode</dt>
              <dd>{variant.barcode}</dd>
            </>
          ) : null}
        </AsnSummaryDetails>
      </CompactDetails>
    ) : null}
  </>
)
